module.exports = __webpack_public_path__ + "media/images/comment-ba046e0c05aabfba8484859977db24e5.png";